module.exports = __webpack_public_path__ + "img/productLogo2.4a95ab0b.svg";